export default [
    {
        "error_id": "XS-STR-01",
        "data": [
            {
                "cross_section": "135",
                "type": "Culvert",
                "section4": "335",
                "section3": "227",
                "section2": "78"
            }
        ]
    }
]